var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1035 0.00381899C15.9573 -0.00479361 15.8086 0.00316742 15.6582 0.0292096H15.6562L1.65625 2.47062C0.705318 2.63679 0 3.47557 0 4.43937V15.5605C0 16.5243 0.705318 17.363 1.65625 17.5292L15.6562 19.9706H15.6582C16.861 20.179 18 19.2221 18 17.9999V1.99991C18 0.930504 17.1273 0.0641076 16.1035 0.00381899ZM15.998 1.99991H16V8.99991H9V3.21866L15.998 1.99991ZM7 3.56827V8.99991H2V4.43937L7 3.56827ZM2 10.9999H7V16.4316L2 15.5605V10.9999ZM9 10.9999H16V17.9999H15.998L9 16.7812V10.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowIcon);
export default __webpack_public_path__ + "static/media/window-icon.39665687d142277c539da2b46c72f29a.svg";
export { ForwardRef as ReactComponent };